import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DomainAuthService {

    constructor(
        private http: CustomHttpService
    ) { }

    getAllClientDomain(data: any): Observable<any> {
        return this.http.post(environment.getAllClientDomain, data);
    }

    authenticateClientDomain(data: any): Observable<any> {
        return this.http.post(environment.authenticateClientDomain, data);
    }

    domainVerificationStatus(data: any): Observable<any> {
        return this.http.post(environment.domainVerificationStatus, data);
    }

    deleteDomainAndEmail(data: any): Observable<any> {
        return this.http.post(environment.deleteDomainAndEmail, data);
    }

    // TODO: Uncomment when backend endpoint is ready
    // deleteDomain(data: any): Observable<any> {
    //     return this.http.post(environment.deleteDomain, data);
    // }

}
